import { LightningElement, api } from "lwc";
import { getAssetsUrl } from "common/helpers";
import bear from "./assets/bear.svg";
import bird from "./assets/bird.svg";
import bench from "./assets/bench.svg";
import butterfly from "./assets/butterfly.svg";
import goat from "./assets/goat.svg";
import hummingBird from "./assets/humming-bird.svg";
import lizard from "./assets/lizard.svg";
import mountain from "./assets/mountain.svg";
import rocks from "./assets/rocks.svg";
import seagull from "./assets/seagull.svg";
import squirrel from "./assets/squirrel.svg";

type ImageVariant =
  | "bird"
  | "bear"
  | "bench"
  | "butterfly"
  | "goat"
  | "humming-bird"
  | "lizard"
  | "mountain"
  | "rocks"
  | "seagull"
  | "squirrel"
  | null;

type Size = "small" | "large";

type Layout = "standard" | "title-top";

export default class EmptyState extends LightningElement {
  @api title: string = "";
  @api description: string = "";
  @api imgVariant: ImageVariant = null;
  @api ctaHref: string = "";
  @api ctaLabel: string = "";
  @api size: Size = "large";
  @api layout: Layout = "standard";
  @api secondaryCtaHref: string = "";
  @api secondaryCtaLabel: string = "";

  get showImage() {
    return !!this.imgVariant;
  }

  get titleFirstLayout() {
    return this.title && this.layout === "title-top";
  }

  get standardLayout() {
    return this.title && this.layout === "standard";
  }

  get showCta() {
    return !!this.ctaHref && !!this.ctaLabel;
  }

  get showSecondaryCta() {
    return !!this.secondaryCtaHref && !!this.secondaryCtaLabel;
  }

  get buttonSize() {
    return this.size === "large" ? "large" : "medium";
  }

  get imageUrl() {
    if (!this.imgVariant) return "";
    return this.assets[this.imgVariant];
  }

  get classes() {
    return `empty-state empty-state--${this.size} empty-state--${this.layout}`;
  }

  private get assets() {
    return {
      bear: getAssetsUrl(bear),
      bird: getAssetsUrl(bird),
      bench: getAssetsUrl(bench),
      butterfly: getAssetsUrl(butterfly),
      goat: getAssetsUrl(goat),
      "humming-bird": getAssetsUrl(hummingBird),
      lizard: getAssetsUrl(lizard),
      mountain: getAssetsUrl(mountain),
      rocks: getAssetsUrl(rocks),
      seagull: getAssetsUrl(seagull),
      squirrel: getAssetsUrl(squirrel),
    };
  }
}
